import Imgix from '../core/Imgix';

export default class PrimaryNavigation {
    constructor() {
        this.imagesRequested = false
        this.imgixInstance = new Imgix(); // register new Imgix instance

        this.states = {
            active: 'is-active',
            navActive: 'navigation--is-active',
            subNavActive: 'sub-menu--is-active',
            mobileDisplay: $('#c-mobile-indicator'),
            originalDisplay: $('#c-mobile-indicator').is(':visible')
        }

        this.lastActivatedLink = null; // Tracks last touched item
        this.suppressMouseEnter = false;

        this.classes = {
            navicon: 'c-menu-button',
            container: 'c-page-header',
            navigation: 'c-nav-primary',
            menu: 'menu',
            subMenu: 'sub-menu-wrapper',
            menuItem: 'menu-item',
            menuItemsHasChildren:'menu-item-has-children',
            menuImages: 'menu-item-image'
        }

        this.elements = {
            body: $('body'),
            navicon: $(`.${this.classes.navicon}`),
            container: $(`.${this.classes.container}`),
            navigation: $(`.${this.classes.navigation}`),
            topLevelMenuItems: $(`.${this.classes.navigation} .${this.classes.menu} > .${this.classes.menuItem}`),
            menuItems: $(`.${this.classes.navigation} .${this.classes.menu} .${this.classes.menuItem}`),
            topLevelMenuItemsActivator: $(`.${this.classes.navigation} .${this.classes.menu} > .${this.classes.menuItem} > a`),
            subMenuActivator: $(`.${this.classes.navigation} .${this.classes.menu} .${this.classes.menuItemsHasChildren} > a`),
            subMenus: $(`.${this.classes.navigation} .${this.classes.menu} .${this.classes.menuItemsHasChildren}`).find(`> .${this.classes.subMenu}`),
            firstSubMenuItems: $(`.${this.classes.navigation} .${this.classes.menu} > .${this.classes.menuItem} > .${this.classes.subMenu} > .${this.classes.menuItemsHasChildren} > a`),
            menuImages: $(`.${this.classes.navigation} .${this.classes.menu} .${this.classes.menuItem} .${this.classes.subMenu} .${this.classes.menuImages}`)
        }

        this.targets = {
            topLevelMenuItemsActivator: `.${this.classes.navigation} .${this.classes.menu} > .${this.classes.menuItem} > a`
        }

        // * Resets navigation when resizing from one breakpoint to the other
        $(window).on('resize', () => {
            // * Runs on 'mobile'
            if(this.states.mobileDisplay.is(':visible') && this.states.mobileDisplay.is(':visible') != this.states.originalDisplay) {
                this.reset(true)

                // * updates original to current display value (immediately after finishing resize)
                return this.states.originalDisplay = this.states.mobileDisplay.is(':visible')
            }

            // * Runs on 'desktop'
            if(!this.states.mobileDisplay.is(':visible') && this.states.mobileDisplay.is(':visible') != this.states.originalDisplay) {
                this.reset(true)

                this.elements.menuImages.each((index, element) => {
                    let isLast = index === this.elements.menuImages.length - 1

                    this.imgixInstance.process(element);

                    if (isLast) {
                        this.imagesRequested = true;
                    }
                })

                // * updates original to current display value (immediately after finishing resize)
                return this.states.originalDisplay = this.states.mobileDisplay.is(':visible')
            }
        }).trigger('resize')

        this.removeNoClickLinks()
        this.wrapWords(this.elements.firstSubMenuItems)
        this.bindEventListeners()
    }

    canHover() {
        return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    // * optional override to remove unusable links on load
    // ! check to prevent link-through
    removeNoClickLinks() {
        if(!$('a[rel*="unlink"').length > 0) return

        $('a[rel*="unlink"').each((i, element) => {
            $(element).removeAttr('href');
        })
    }

    wrapWords(e) {
        e.each((i, v) => {
            $(v).contents().eq(0).wrap('<span>')
            $(v).append('<span>View all</span>')
        })
    }

    bindEventListeners() {
        // * navicon actions
        this.elements.navicon.on('click', (e) => {
            e.preventDefault()

            // * If menu is already active, cancel out and reset
            if(this.elements.body.hasClass(this.states.navActive)) return this.reset(true)

            // * Applies delays to mobile view only
            if (this.states.mobileDisplay.is(':visible')) {
                const topLevelMenuItems = Array.from(this.elements.topLevelMenuItems);
                topLevelMenuItems.forEach((item, index) => {
                    item.style.transitionDelay = `${index * 0.1}s`;
                });
            }

            this.elements.body.addClass(this.states.navActive)
        })

        // * Register Document Events (allows for dynamic triggers)
        $(document)
            // * Top Level Nav Item Event Triggers
            .on('click mouseenter focusin', `${this.targets.topLevelMenuItemsActivator}`, (e) => {
                const $target = $(e.target)

                if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) {
                    return;
                }

                if (e.type !== 'focusin') e.preventDefault()

                if (e.type === 'click') {
                    let lastActivatedLink = this.lastActivatedLink,
                        hasSubMenu = $target.siblings(`.${this.classes.subMenu}`).length > 0,
                        isMobile = this.states.mobileDisplay.is(':visible');

                    if (!hasSubMenu) {
                        if($target.attr('rel') === 'unlink' || !$target.attr('href')) return

                        if ($target.attr('target') === '_blank') {
                            window.open($target.attr('href'), '_blank');
                            return
                        }

                        return window.location = $target.attr('href');
                    }

                    // Tablet or touch device handling
                    if (hasSubMenu) {
                        if (lastActivatedLink === $target.get(0) && !isMobile) {
                            window.location = $target.attr('href');
                            return;
                        } else {
                            e.preventDefault();
                            this.lastActivatedLink = $target.get(0);
                            this.toggleSubNavs(e);
                            $('body').addClass(this.states.navActive);
                            return;
                        }
                    }
                }

                if ((e.type === 'mouseenter' && this.canHover()) || e.type === 'focusin') {
                    if (this.suppressMouseEnter) return; // skip hover if just clicked
                    if(this.states.mobileDisplay.is(':visible')) return

                    this.lastActivatedLink = $target.get(0)

                    $('body').addClass(this.states.navActive)
                    this.toggleSubNavs(e)
                }
            })
            // * Leave Window/Viewport Event Triggers
            .on('mouseleave', (e) => {
                if(!$('body').hasClass(this.states.navActive)) return;
                let viewport = (e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight));

                if(viewport && window.innerWidth >= 1024) return this.reset(true)
            })
            // * Leave Header Event Triggers
            .on('mouseleave', `.${this.classes.container}`, (e) => {
                // * If mouse leaves header then reset navigation
                if(!$(e.toElement).parents().hasClass(`${this.classes.container}`) && window.innerWidth >= 1024) return this.reset(true)
            })
            // * Focusin handler for submenu items to retrigger parent top-level link
            .on('focusin', `.${this.classes.subMenu} a`, (e) => {
                const $focused = $(e.target);
                if (this.states.mobileDisplay.is(':visible')) return; // Skip mobile

                // Find the related top-level link
                const $topLevelLink = $focused.closest(`.${this.classes.menuItem}`).closest(`.${this.classes.subMenu}`).siblings('a').first();

                if ($topLevelLink.length) {
                    // Simulate focus logic
                    this.lastActivatedLink = $topLevelLink.get(0);
                    $('body').addClass(this.states.navActive);
                    this.toggleSubNavs({ type: 'focusin', target: $topLevelLink.get(0), preventDefault: () => {} });
                }
            });
    }

    toggleSubNavs(e) {
        e.preventDefault()

        // * desktop fired
        if(!this.states.mobileDisplay.is(':visible')) {
            // * Remove parent's > sibling's > children's active states to prevent multiple tabs being opened
            $(e.target).parent().siblings().children().removeClass(this.states.active)

            // * Apply sub-menu class to body
            if($(e.target).siblings(`.${this.classes.subMenu}`).length > 0) {
                $(e.target).siblings(`.${this.classes.subMenu}`).addClass(this.states.active)
                this.elements.body.addClass(this.states.subNavActive);
            } else {
                this.elements.body.removeClass(this.states.subNavActive);
            }

            $(e.target).addClass(this.states.active)
        }

        // * mobile fired
        if(this.states.mobileDisplay.is(':visible')) {
            $(e.target).parent().siblings().children().removeClass(this.states.active).siblings(`.${this.classes.subMenu}`).hide(300).children().removeClass(this.states.active)

            setTimeout(() => {
                $(e.target).toggleClass(this.states.active).siblings(`.${this.classes.subMenu}`).toggleClass(this.states.active).toggle(300)
            }, 300);
        }
    }

    reset($closeNavigation = false) {
        this.lastActivatedLink = null; // Reset touch-click state

        // * Add classes to reset outside of nav closure - toggling between sub menus etc
        this.elements.menuItems.children().removeClass(this.states.active)

        // * Closes nav completely if true is passed into argument
        if(!$closeNavigation) return

        // * If on/or resizing from mobile remove transition delays
        if(this.states.mobileDisplay.is(':visible') || this.states.originalDisplay == true) {
            this.elements.topLevelMenuItems.each(function() {
                $(this).removeAttr("style")
            })
        }

        this.elements.subMenus.removeAttr("style")
        this.elements.body.removeClass(`${this.states.navActive} ${this.states.subNavActive}`)
    }
};
